import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardsReducer } from '.';

export const featureSelector = createFeatureSelector<DashboardsReducer.State>('dashboards');

export const isLoadingDashboards = createSelector(
  featureSelector,
  state => state.loadingDashboards
);

export const isCopyingDashboard = createSelector(
  featureSelector,
  state => state.copyingDashboard
);

export const isDeletingDashboard = createSelector(
  featureSelector,
  state => state.deletingDashboard
);

export const isSharingDashboard = createSelector(
  featureSelector,
  state => state.sharingDashboard
);

export const isTogglingDashboardLibrary = createSelector(
  featureSelector,
  state => state.togglingDashboardLibrary
);


export const getDashboards = createSelector(
  featureSelector,
  state => state.dashboards
);

export const getSelectedDashboardId = createSelector(
  featureSelector,
  state => state.selectedDashboardId
);

export const getDisplayParams = createSelector(
  featureSelector,
  state => state.displayParams
);
